import { TEXTS } from "../../constants";
import MovedToTemplatesNotice from "./MovedToTemplatesNotice";

const CompanyForm = () => (
  <MovedToTemplatesNotice message={TEXTS.movedToTemplates.globalPermission} />
);

export default CompanyForm;
